(function(angular, _) {
    'use strict';

    angular.module('wtApp.dataService')
        .factory('WtPageDetailAnalysis', ['WtAnalysis', function(WtAnalysis) {
            /**
             * @ngdoc service
             * @name WtPageDetailsAnalysis
             * @description Page detail analysis constructor.
             * This is an analysis that is created in the frontend as supportive sub-analyses to display the page_detail predefined analysis.
             * The page detail sub-analyses are not persisted on the backend
             */
            class WtPageDetailAnalysis extends WtAnalysis {
                /**
                 * @ngdoc method
                 * @name WtPageDetailAnalysis.validate
                 * @description Provides a utility method to validate a configuration object if it is a valid page detail analysis
                 * @param {Object} config The analysis configuration
                 * @throws Error
                 */
                static validate(config) {
                    // Validates the sub analyses
                    if (!_.hasIn(config, 'configJson') || !_.isObject(config.configJson)) {
                        throw Error('Page detail analysis missing analysis configuration');
                    }

                    if (!_.hasIn(config, 'id')) {
                        throw Error('Page detail analysis missing report element id');
                    }

                    if (!_.hasIn(config, 'reportId')) {
                        throw Error('Page detail analysis missing report id');
                    }
                }

                /**
                 * @ngdoc property
                 * @name WtPageDetailAnalysis#pristineConfig
                 * @description Exposes the pristine analysis configuration object to the outer world.
                 * Note that for analyses that hide the analysis configuration under configJson (report analyses, KPIs, Sparklines), the configJson value is returned by this property
                 * @returns {Object}
                 */
                get pristineConfig() {
                    return this.pristineData_.configJson;
                }

                /**
                 * @ngdoc property
                 * @name WtPageDetailAnalysis#config
                 * @description Exposes the analysis configuration object to the outer world
                 * Note that for analyses that hide the analysis configuration under configJson (report analyses, KPIs, Sparklines), the configJson value is returned by this property
                 * @returns {Object}
                 */
                get config() {
                    return this.data_.configJson;
                }

                constructor() {
                    super(...arguments);

                    // Adds older browsers support (IE < 11)
                    this.constructor = this.constructor || WtPageDetailAnalysis;

                    this.hideTable();
                }

                /**
                 * @ngdoc method
                 * @name WtPageDetailAnalysis#isSparkline
                 * @description Checks if the current instance is a sub analysis of type sparkline
                 * @returns {boolean}
                 */
                isSparkline() {
                    return this.get('standardChart') === 'AREA';
                }
            }

            return WtPageDetailAnalysis;
        }]);
})(window.angular, window._);
